export default __webpack_public_path__ + "static/media/nikas.79ceee6e.png";